import React from 'react';
import { Store } from 'pullstate';
import { Dialog } from '@mui/material';
import { IconButton } from '@mui/material';
import CloseIcon from '@mui/icons-material/Close';
import { PuzzleStoreBase } from '../../../utils/types';
import './RevealConfirmationDialog/RevealConfirmationDialog.less';

type RevealConfirmationDialogProps = {
  isOpen: boolean;
  onConfirm: () => void;
  onClose: () => void;
  store: Store<PuzzleStoreBase>;
  prompt?: string; // only used to differentiate Clear All from the check/reveal confirms
};

const CustomRevealConfirmationDialog = ({ isOpen, onConfirm, onClose, prompt, store }: RevealConfirmationDialogProps) => {
  const onCloseWrapper = () => {
    store.update(s => { s.isSoftPaused = false; });
    onClose();
  };

  const onConfirmWrapper = () => {
    store.update(s => { s.isSoftPaused = false; });
    onConfirm();
    onClose();
  };

  const displayPrompt = prompt || 'Are you utterly certain? This puzzle will count as revealed and be excluded from any solve streak.';

  return (
    <Dialog open={isOpen} onClose={onClose}>
      <div className="revealConfirmationDialogContent">
        <IconButton className="closeButton" onClick={onClose}>
          <CloseIcon/>
        </IconButton>
        <div className="prompt">
          {displayPrompt}
        </div>
        <button className="decisionButton" onClick={onCloseWrapper}>Cancel</button>
        <button className="decisionButton revealButton" onClick={onConfirmWrapper}>Confirm</button>
      </div>
    </Dialog>
  );
};

export default CustomRevealConfirmationDialog;